class CartDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.drawer = this.querySelector('#CartDrawer');
    this.overlay = this.querySelector('#CartDrawer-Overlay');
    this.closeButton = this.querySelector('.cart-drawer__close');
    this.cartIcon = document.querySelector('#cart-icon-bubble');

    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('cart:updated', this.onCartUpdated.bind(this));
    
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }

    if (this.cartIcon) {
      this.cartIcon.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }

    // Bind quantity changes
    this.addEventListener('change', this.onChange.bind(this));
  }

  open() {
    if (this.drawer && this.overlay) {
      this.drawer.style.transform = 'translateX(0)';
      this.overlay.style.visibility = 'visible';
      this.overlay.style.opacity = '1';
      document.body.style.overflow = 'hidden';
    }
  }

  close() {
    if (this.drawer && this.overlay) {
      this.drawer.style.transform = 'translateX(100%)';
      this.overlay.style.opacity = '0';
      setTimeout(() => {
        this.overlay.style.visibility = 'hidden';
      }, 300);
      document.body.style.overflow = '';
    }
  }

  onCartUpdated(event) {
    if (event.detail && event.detail.cart) {
      this.renderContents(event.detail.cart);
      this.open();
    }
  }

  onChange(event) {
    if (event.target.classList.contains('quantity__input')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }

  updateQuantity(line, quantity) {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    };

    fetch(window.routes.cart_change_url, config)
      .then((response) => response.json())
      .then((state) => {
        if (state.sections && state.sections['cart-drawer']) {
          this.renderContentsFromSection(state.sections['cart-drawer']);
        } else {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  renderContentsFromSection(html) {
    const template = document.createElement('div');
    template.innerHTML = html;
    
    const newItems = template.querySelector('#CartDrawer-CartItems');
    const newSubtotal = template.querySelector('#CartDrawer-Subtotal');
    
    if (newItems && this.querySelector('#CartDrawer-CartItems')) {
      this.querySelector('#CartDrawer-CartItems').innerHTML = newItems.innerHTML;
    }
    
    if (newSubtotal && this.querySelector('#CartDrawer-Subtotal')) {
      this.querySelector('#CartDrawer-Subtotal').innerHTML = newSubtotal.innerHTML;
    }

    const newForm = template.querySelector('#CartDrawer-Form');
    const checkoutBtn = this.querySelector('#CartDrawer-Checkout');
    if (checkoutBtn) {
      if (!newForm) {
        checkoutBtn.setAttribute('disabled', 'true');
      } else {
        checkoutBtn.removeAttribute('disabled');
      }
    }
    
    this.updateCartIcon();
  }

  renderContents(cartData) {
    fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const cartDrawerHtml = html.querySelector('cart-drawer');
        if (cartDrawerHtml) {
          this.innerHTML = cartDrawerHtml.innerHTML;
          this.drawer = this.querySelector('#CartDrawer');
          this.overlay = this.querySelector('#CartDrawer-Overlay');
          this.closeButton = this.querySelector('.cart-drawer__close');
          this.bindEvents();
          this.updateCartIcon();
        }
      })
      .catch(e => console.error(e));
  }
  
  updateCartIcon() {
    fetch(`${window.routes.cart_url}.js`)
      .then(r => r.json())
      .then(cart => {
        const bubble = document.querySelector('.cart-count-bubble span');
        if (bubble) {
          bubble.textContent = cart.item_count;
        } else if (cart.item_count > 0) {
          const icon = document.querySelector('#cart-icon-bubble');
          if (icon) {
            const newBubble = document.createElement('div');
            newBubble.className = 'cart-count-bubble';
            newBubble.style.cssText = 'position: absolute; top: -5px; right: -5px; background: rgb(var(--color-base-accent-1)); color: white; border-radius: 50%; font-size: 0.7rem; width: 16px; height: 16px; display: flex; align-items: center; justify-content: center;';
            newBubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
            icon.appendChild(newBubble);
          }
        }
      });
  }
}

customElements.define('cart-drawer', CartDrawer);
